export const IN8IT_LOGIN_SUCCESS = "IN8IT_LOGIN_SUCCESS";
export const IN8IT_LOGIN_FAIL = "IN8IT_LOGIN_FAIL";
